import {Injectable} from '@angular/core';
import {BaseProvider} from '../base.provider';
import {TechnicalDocumentsService} from './technical-documents.service';

/**
 * Провайдер территориальных органов ростеха
 */

@Injectable()
export class TechnicalDocumentsProvider extends BaseProvider<TechnicalDocument[]> {
    public defaultValue = [];

    constructor(
        service: TechnicalDocumentsService
    ) {
        super(service);
        /**
         * Устанавливаем дефолтные значения
         */
        this.data$.next(this.defaultValue);
        this.updateData();
    }

    /**
     * Получить список общих документов НТД.
     * У общих документов нет ни объекта, ни метода
     */
    getCommonDocuments(): TechnicalDocument[] {
        const documents = this.data$.getValue();
        return documents.filter(doc => Boolean(!doc.method_id && !doc.object_id));
    }

    /**
     * Получить документы, имеющие метод (привязанные к методу).
     * Некоторые документы могуть быть полностью одинаковыми, за исключением объектов, а раз нам объекты тут не важны,
     * то сразу исключим дубли
     */
    getDocumentsWithMethod(): TechnicalDocument[] {
        const documents = this.data$.getValue();
        const uniqCodes: string[] = [];
        return documents.filter(doc => {
            /**
             * Берем только документы, у которых указан метод и которые мы еще не брали, проверяя их по short_code
             */
            if (Boolean(doc.method_id) && uniqCodes.indexOf(doc.short_code) < 0) {
                uniqCodes.push(doc.short_code);
                return true;
            } else {
                return false;
            }
        });
    }

    /**
     * Получить документы, имеющие объект (привязанные к объекту)
     */
    getDocumentsWithObject(): TechnicalDocument[] {
        const documents = this.data$.getValue();
        return documents.filter(doc => Boolean(doc.object_id));
    }
}

export interface TechnicalDocument {
    id: number;
    method_id: number;
    object_id: number;
    title: string;
    short_code: string;
}
